import React, { useState, FunctionComponent } from "react";
import clsx from "clsx";
import { Button, ListItem, makeStyles, Collapse } from "@material-ui/core";
import { Icon } from "react-feather";

const useStyles = makeStyles((theme) => ({
  item: {
    display: "block",
    paddingTop: 0,
    paddingBottom: 0,
  },
  title: {
    marginRight: "auto",
  },
  button: {
    padding: "10px 8px",
    justifyContent: "flex-start",
    textTransform: "none",
    letterSpacing: 0,
    width: "100%",
  },
  icon: {
    display: "flex",
    alignItems: "center",
    marginRight: theme.spacing(1),
  },
  children: {
    paddingLeft: 24,
  },
}));

interface AppNavHeader {
  title: string;
  isOpen?: boolean;
  icon?: Icon;
}

const AppNavSection: FunctionComponent<
  AppNavHeader & React.HTMLAttributes<HTMLDivElement>
> = ({ title, className, children, isOpen, icon: SectionIcon }) => {
  const classes = useStyles();

  const [open, setOpen] = useState(isOpen);
  const handleToggle = () => {
    setOpen((prevOpen: any) => !prevOpen);
  };

  return (
    <ListItem className={clsx(classes.item, className)} disableGutters>
      <Button className={classes.button} onClick={handleToggle}>
        {SectionIcon && <SectionIcon className={classes.icon} size="20" />}
        <span className={classes.title}>{title}</span>
      </Button>
      <Collapse in={!!open} className={classes.children}>
        {children}
      </Collapse>
    </ListItem>
  );
};

export default AppNavSection;
